<template>
  <div class="snst-error-container">
    <div class="snst-error-content snst-error-404 clearfix">
      <img src="./img/404.png"
        class="fl"
        alt=""
        style="width:346px;height: 244px">
      <div class="snst-error-text fl">
        <p>抱歉</p>
        <p class="error-tips">你访问的页面不存在！</p>
        <p class="btn-gohome"
          @click="gohome">返回首页
        </p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  methods: {
    gohome() {
      this.$router.push({
        path: "/home"
      });
    }
  }
};
</script>